export default __webpack_public_path__ + "static/media/edital09alt.0bfc4d13.pdf";